import { render } from "./OlderBalances.vue?vue&type=template&id=ac997780&scoped=true"
import script from "./OlderBalances.vue?vue&type=script&lang=js"
export * from "./OlderBalances.vue?vue&type=script&lang=js"

import "./OlderBalances.vue?vue&type=style&index=0&id=ac997780&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac997780"]])

export default __exports__